import {
  HOME_DELETE_SEASON_BEGIN,
  HOME_DELETE_SEASON_SUCCESS,
  HOME_DELETE_SEASON_FAILURE,
  HOME_DELETE_SEASON_DISMISS_ERROR,
} from './constants';

import axios from 'axios';

function removeElement(obj, keyToRemove)
{
  let result = {};
  
  Object.keys(obj).forEach(k => {
    //compare with == because k is string and keyToRemove number. Why?
    if (k == keyToRemove) return;
    result[k] = obj[k];
  })
  return result;
}

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function deleteSeason(season) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_DELETE_SEASON_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      axios.delete("/api/seasons/"+season.id).then(
        (res) => {
          dispatch({
            type: HOME_DELETE_SEASON_SUCCESS,
            data: season,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_DELETE_SEASON_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteSeasonError() {
  return {
    type: HOME_DELETE_SEASON_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_DELETE_SEASON_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteSeasonPending: true,
        deleteSeasonError: null,
      };

    case HOME_DELETE_SEASON_SUCCESS:
      // The request is success
      
      const {[action.data.id]: value,...newSeasons} = state.seasons;
      console.log({newSeasons, data: action.data, value})
      return {
        ...state,
        deleteSeasonPending: false,
        deleteSeasonError: null,
        seasons: removeElement(state.seasons, action.data.id)
      };

    case HOME_DELETE_SEASON_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteSeasonPending: false,
        deleteSeasonError: action.data.error,
      };

    case HOME_DELETE_SEASON_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteSeasonError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/deleteSeason.js